module.exports = __webpack_public_path__ + "img/cn.2920a0fa.jpg";